<template>
  <div class="p-field p-col-12 p-lg-3">
    <AppFormItem label="Fazenda" :error="error">
      <AutocompleteApi
        :value="farm"
        :valueId="farmId"
        @update:value="$emit('update:farm', $event)"
        @update:valueId="$emit('update:farmId', $event)"
        :search="fetchFarms"
        :disabled="disabled"
      ></AutocompleteApi>
    </AppFormItem>
  </div>
</template>

<script>
import AutocompleteApi from '../../../components/AutocompleteApi.vue';
import { FarmApi } from '../../../services/api';

export default {
  name: 'ServiceEditFarm',
  components: {
    AutocompleteApi,
  },
  props: {
    error: Object,
    farm: Object,
    farmId: Number,
    customer: Object,
    disabled: Boolean,
  },
  methods: {
    fetchFarms(query) {
      return FarmApi.fetch(query, { accessToken: this.customer?.accessToken });
    },
  },
};
</script>

<style>
</style>